import API_BASE_URL from "./config";

const fetchData = async (endpoint, params = "", options = {}) => {
  const url = new URL(`${API_BASE_URL}${endpoint}`);

  // If params is an object, convert it to query string
  if (typeof params === "object" && params !== null) {
    url.search = new URLSearchParams(params).toString();
  } else if (typeof params === "string") {
    url.search = params;
  }

  // Attach auth token from localStorage
  const token = localStorage.getItem("authToken");
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  try {
    const response = await fetch(url.toString(), { ...options, headers });

    // 401s are handled globally in src/index.js

    // The API returns { status, error, message, path } on failure. Surface the
    // message on its own -- it is written to be read by a person, and dumping
    // the whole JSON blob into an alert buried it.
    if (!response.ok) {
      let message = `${response.status} ${response.statusText}`;
      try {
        const errorData = await response.json();
        if (errorData?.message) {
          message = errorData.message;
        }
      } catch (parseError) {
        // Non-JSON error body; the status line above is the best we have.
      }
      const error = new Error(message);
      error.status = response.status;
      throw error;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("API Fetch Error:", error);
    throw error;
  }
};

export default fetchData;
